"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = startUILoading;
var _types = require("./types");
function startUILoading(key) {
  return function (dispatch) {
    var action = {
      type: _types.UI_LOADING_START,
      key: key
    };
    dispatch(action);
  };
}